<template>
  <div id="guide" class="pc">
    <ul id="guide__nav">
      <li><router-link to="#grid">グリッド</router-link></li>
      <li><router-link to="#heading">見出し</router-link></li>
      <li><router-link to="#text">テキスト</router-link></li>
      <li><router-link to="#form">フォーム</router-link></li>
      <li><router-link to="#list">リスト</router-link></li>
      <li><router-link to="#table">テーブル</router-link></li>
      <li><router-link to="#button">ボタン</router-link></li>
      <li><router-link to="#tab">タブ</router-link></li>
    </ul>
    <h1 class="guide__title">汎用パーツ一覧用ページ</h1>
    <section id="grid">
      <h2 class="guide__title">グリッド</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.column カラムレイアウト</p>
          <div class="column">
            <div class="column-item col-12"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">12カラム</div></div>
            <div class="column-item col-11"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">11カラム</div></div>
            <div class="column-item col-10"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">10カラム</div></div>
            <div class="column-item col-9"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">9カラム</div></div>
            <div class="column-item col-8"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">8カラム</div></div>
            <div class="column-item col-7"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">7カラム</div></div>
            <div class="column-item space-right col-6"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">6カラム（右マージン）</div></div>
            <div class="column-item space-right col-5"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">5カラム（右マージン）</div></div>
            <div class="column-item col-4"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">4カラム</div></div>
            <div class="column-item space-left col-3"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">3カラム（左マージン）</div></div>
            <div class="column-item space-left col-2"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">2カラム（左マージン）</div></div>
            <div class="column-item space-left col-1"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">1カラム（左マージン）</div></div>
          </div>
          <p class="guide__desc">.column カラムレイアウト（ガーター）</p>
          <div class="column gutter">
            <div class="column-item space-gutter col-6"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">6カラム（ガーターマージン）</div></div>
            <div class="column-item space-gutter col-6"><div style="background-color:#ddd;margin-bottom:10px;text-align:center;">6カラム（ガーターマージン）</div></div>
          </div>
          <p>※マージン調整用クラスとして、0px ~ 120px まで4px刻みで用意されています。種類は.mtXX, mrXX, mbXX, mlXX, ptXX, prXX, pbXX, plXXがあります。（XXは数値）<br>
          例) 上マージンを40px撮りたい場合<br>
          &lt;p class=&quot;mt40&quot;&gt;上マージンを40px取りたい要素&lt;/p&gt;</p>
        </div>
      </div>
    </section>
    <section id="heading">
      <h2 class="guide__title">見出し</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.hdg0X 見出し</p>
          <h1 class="hdg01">h1見出し 32px - 3.2rem - 3B4557</h1>
          <h2 class="hdg02">h2見出し 28px - 2.8rem - 3B4557</h2>
          <h3 class="hdg03">h3見出し 24px - 2.4rem - 3B4557</h3>
          <h4 class="hdg04">h4見出し 20px - 2.0rem - 3B4557</h4>
          <h5 class="hdg05">h5見出し 16px - 1.6rem - 3B4557</h5>
          <h5 class="hdg05"><router-link to="#" class="txt-blue">h5見出しリンク 16px - 2em - 005BAC</router-link></h5>
          
          
          <p class="guide__desc">※見出し＋見出し、見出し＋本文が連続する場合はヘルパークラスで調整</p>
          <h1 class="hdg01 mb24">h1見出し 32px - 3.2rem - 3B4557 .mb24</h1>
          <h2 class="hdg02 mb24">h2見出し 28px - 2.8rem - 3B4557 .mb24</h2>
          <h3 class="hdg03 mb16">h3見出し 24px - 2.4rem - 3B4557 .mb16</h3>
          <h4 class="hdg04 mb16">h4見出し 20px - 2.0rem - 3B4557 .mb16</h4>
          
          
          <p class="guide__desc">※見出し + 本文の場合 -> 見出しモジュールのしたマージンを36px(.mb36)とる。</p>
          <h3 class="hdg03 mb28">h3見出し 24px - 2.4rem - 3B4557 .mb28</h3>
          <p class="txt">吾輩わがはいは猫である。名前はまだ無い。どこで生れたかとんと見当けんとうがつかぬ。</p>
          <p class="guide__desc">※見出し + 補足の場合 -> 見出しモジュールのしたマージンを4px(.mb4)とる。</p>
          <h3 class="hdg03 mb4">h3見出し 24px - 2.4rem - 3B4557 .mb36</h3>
          <p class="txt-sup">2020/04/04</p>

          
          <p class="guide__desc">.hdg0X.line 左線つき見出し</p>
          <h1 class="hdg01 line">新規ノートを作成して保存する</h1>
          <h2 class="hdg02 line">新規ノートを作成して保存する</h2>
          <h3 class="hdg03 line">新規ノートを作成して保存する</h3>
          <h4 class="hdg04 line">新規ノートを作成して保存する</h4>
          <h5 class="hdg05 line">新規ノートを作成して保存する</h5>
        </div>
      </div>
    </section>
    <section id="text">
      <h2 class="guide__title">テキスト</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.txt 汎用テキスト</p>
          <p class="txt">本文テキスト サイズ中 16px - 1.6rem - 555 <br>吾輩わがはいは猫である。名前はまだ無い。どこで生れたかとんと見当けんとうがつかぬ。<router-link to="#" class="txt-blue">何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。</router-link>吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪どうあくな種族であったそうだ。この書生というのは時々我々を捕つかまえて煮にて食うという話である。しかしその当時は何という考もなかったから別段恐しいとも思わなかった。</p>
          
          <p class="guide__desc">.txt-sup 補足テキスト</p>
          <p class="txt-sup">補足テキスト サイズ中 14px - 1.4rem - 999 <br>吾輩わがはいは猫である。名前はまだ無い。どこで生れたかとんと見当けんとうがつかぬ。何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪どうあくな種族であったそうだ。この書生というのは時々我々を捕つかまえて煮にて食うという話である。しかしその当時は何という考もなかったから別段恐しいとも思わなかった。</p>
          

          <p class="guide__desc">.box01 ボックス</p>
          <div class="pt20 pb20 pr20 pl20" style="background-color:#525A65;">
            <div class="box01 mb20">
              <router-link to="" class="box01-link">ダッシュボード</router-link>
            </div>
            <div class="box01 is-inactive">
              <router-link to="" class="box01-link">ダッシュボード(非活性)</router-link>
            </div>
          </div>

          <p class="guide__desc">.box02 ボックス</p>
          <div style="background-color:rgba(0,0,0,.3);padding:20px;">
            <div class="box02 white">
              <div class="box02-hdg">
                <h1 class="box02-hdg-title hdg03">検索結果</h1>
                <span class="box02-hdg-title-sup">30,000件</span>
                <div class="box02-hdg-aside">
                  <router-link to="" class="box02-hdg-aside-menu">検索条件の保存</router-link>
                  <router-link to="" class="box02-hdg-aside-menu">表示設定</router-link>
                </div>
              </div>
              <div class="box02-body">
                コンテンツが入ります。
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
    <section id="form">
      <h2 class="guide__title">フォーム</h2>
      <div class="guide__module">
        <div class="guide__example">

          <p class="guide__desc">.formparts.search キーワード入力欄</p>
          <div class="formparts search">
            <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
            <input type="text" name="search" placeholder="キーワードを入力">
          </div>

          <p class="guide__desc">.formparts.function 機能つき入力欄</p>
          <div class="formparts function">
            <input type="text" name="search" placeholder="キーワードを入力">
            <div class="button" role="button"><FontawesomeIcon icon="plus" class="icn" /></div>
          </div>
          <div class="formparts function">
            <input type="text" name="search" placeholder="キーワードを入力">
            <div class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
          </div>
          <div class="formparts function file">
            <input type="file" name="file" id="file_upload" placeholder="キーワードを入力">
            <span class="fake-txt"></span>
            <label for="file_upload"><div class="button" role="button">アップ</div></label>
          </div>
          <div class="formparts function suggest" style="margin-bottom:200px;">
            <input type="text" name="search" placeholder="キーワードを入力">
            <div class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
            <ul class="suggest-list">
              <li role="option"><label>選択肢1<input type="radio" name="rd_group_02"></label></li>
              <li role="option"><label>選択肢2<input type="radio" name="rd_group_02"></label></li>
              <li role="option"><label>選択肢3<input type="radio" name="rd_group_02"></label></li>
              <li role="option"><label>選択肢4<input type="radio" name="rd_group_02"></label></li>
            </ul>
          </div>

          <p class="guide__desc">.formparts.text 通常テキスト入力欄</p>
          <div class="formparts text">
            <input type="text" name="text" placeholder="テキストを入力">
          </div>
          <p class="error-message">エラーメッセージが入ります。エラーメッセージが入ります。エラーメッセージが入ります。</p>
          <div class="formparts text">
            <input type="email" name="email" placeholder="yamada-taro@sn-hoki.co.jp">
          </div>
          <div class="formparts text">
            <input type="password" name="password" placeholder="*********">
          </div>
          <div class="formparts text is-inactive">
            <input type="password" name="text" placeholder="非活性">
          </div>

          <p class="guide__desc">.formparts.textarea 複数行入力欄</p>
          <div class="formparts textarea">
            <textarea name="" id="" rows="5" placeholder="ご質問などがありましたら、ご入力ください。デフォルトで5行分"></textarea>
          </div>
          <div class="formparts textarea is-inactive">
            <textarea name="" id="" rows="5" placeholder="非活性"></textarea>
          </div>

          <p class="guide__desc">.formparts.checkbox(.radio) チェックボックス・ラジオボタン</p>
          <div class="formparts checkbox is-disable">
            <input type="checkbox" name="group_cb_01" id="cb_01_00">
            <label for="cb_01_00">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts checkbox">
            <input type="checkbox" name="group_cb_01" id="cb_01_01">
            <label for="cb_01_01">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts checkbox">
            <input type="checkbox" name="group_cb_01" id="cb_01_02">
            <label for="cb_01_02">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts checkbox is-inactive">
            <input type="checkbox" name="group_cb_01" id="cb_01_03">
            <label for="cb_01_03">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts radio">
            <input type="radio" name="group_rb_01" id="rd_01_01">
            <label for="rd_01_01">税務・会計</label>
          </div>
          <div class="formparts radio">
            <input type="radio" name="group_rb_01" id="rd_01_02">
            <label for="rd_01_02">税務・会計</label>
          </div>
          <div class="formparts radio is-inactive">
            <input type="radio" name="group_rb_01" id="rd_01_03">
            <label for="rd_01_03">税務・会計</label>
          </div>

          <p class="guide__desc">.formparts.checkbox(.radio) チェックボックス・ラジオボタン(インラインブロック)</p>
          <div class="formparts checkbox inline">
            <input type="checkbox" name="group_cb_01" id="cb_01_04">
            <label for="cb_01_04">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts checkbox inline">
            <input type="checkbox" name="group_cb_01" id="cb_01_05">
            <label for="cb_01_05">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts checkbox inline is-inactive">
            <input type="checkbox" name="group_cb_01" id="cb_01_06">
            <label for="cb_01_06">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
          </div>
          <div class="formparts radio inline">
            <input type="radio" name="group_rb_01" id="rd_01_04">
            <label for="rd_01_04">税務・会計</label>
          </div>
          <div class="formparts radio inline">
            <input type="radio" name="group_rb_01" id="rd_01_05">
            <label for="rd_01_05">税務・会計</label>
          </div>
          <div class="formparts radio inline is-inactive">
            <input type="radio" name="group_rb_01" id="rd_01_06">
            <label for="rd_01_06">税務・会計</label>
          </div>
          
          
          <!-- todo: 選択肢したリストに項目を.select-labelにバインド -->
          <p class="guide__desc">.formpart.select セレクトボックス</p>
          <div class="formparts select is-visible-list" style="margin-bottom:180px;">
            <div class="select-label ta-center" role="select">ライセンス数を選択<FontawesomeIcon icon="angle-down" class="icn" /></div>
            <div class="select-label ta-center" role="select">ライセンス数を選択※アクティブ<FontawesomeIcon icon="angle-up" class="icn" /></div>
            <div class="select-option">
              <ul class="select-option-list ta-center">
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢1</label></li>
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢2</label></li>
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢3</label></li>
              </ul>
            </div>
          </div>
          <div class="formparts select is-visible-list" style="margin-bottom:180px;">
            <div class="select-label" role="select">ライセンス数を選択<FontawesomeIcon icon="angle-down" class="icn" /></div>
            <div class="select-option">
              <ul class="select-option-list ta-center">
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢1</label></li>
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢2</label></li>
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢3</label></li>
              </ul>
            </div>
          </div>
          <div class="formparts select is-selected" style="margin-bottom:180px;">
            <div class="select-label" role="select">洗濯済み<FontawesomeIcon icon="angle-down" class="icn" /></div>
            <div class="select-option">
              <ul class="select-option-list ta-center">
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢1</label></li>
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢2</label></li>
                <li class="ta-center" role="option"><label><input type="radio" name="group_rd_02">選択肢3</label></li>
              </ul>
            </div>
          </div>

          <div class="tbl02">
            <table class="tbl">
              <colgroup>
                <col style="width:33.333%;">
                <col style="width:66.666%;">
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    <span class="hdg05">名前 <span class="txt-red">[必須]</span></span>
                  </th>
                  <td>
                    <span class="txt">名前</span>
                    <div class="formparts text">
                      <input type="text" name="" placeholder="山田太郎">
                    </div>
                    <p class="txt-sup">名前に関する注記名前に関する注記名前に関する注記名前に関する注記名前に関する注記名前に関する注記名前に関する注記</p>
                  </td>
                </tr>
                <tr>
                  <th class="pt20">
                    <span class="hdg05">メールアドレス <span class="txt-red">[必須]</span> ※tdの初めの項目が枠付きの場合は ".pt20"</span>
                  </th>
                  <td>
                    <div class="formparts text">
                      <input type="email" name="email" placeholder="yamada-taro@sn-hoki.co.jp">
                    </div>
                    <p class="txt mb16">もう一度入力してください</p>
                    <div class="formparts text">
                      <input type="email" name="email_2" placeholder="yamada-taro@sn-hoki.co.jp">
                    </div>
                    <p class="txt-sup">メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記</p>
                  </td>
                </tr>
                <tr>
                  <th>
                    <span class="hdg05">住所 <span class="txt-red">[必須]</span></span>
                  </th>
                  <td>
                    <p class="txt-sup">郵便番号から住所検索を実行してください。システムの都合上、半角文字はすべて全角に変換されます。お手元に請求書若しくは納品書がある場合は、記載されているとおりに住所をご入力ください。<br>（例）「３－１－８」と記載されている場合は、正式な表記が「３丁目１番８号」だとしても、「３－１－８」とご入力ください。</p>
                    <p class="txt">郵便番号 <span class="txt-red">[必須]</span></p>
                    <div class="column gutter">
                      <div class="column-item col-4 space-gutter">
                        <div class="formparts text">
                          <input class="ta-center" type="text" name="" placeholder="郵便番号">
                        </div>
                      </div>
                      <div class="column-item col-4 space-gutter">
                        <div class="button">
                          <button type="button" class="btn">決定</button>
                        </div>
                      </div>
                      <div class="column-item col-4 gutter flex al-center">
                        <span class="txt-sup">例:448****</span>
                      </div>
                    </div>      
                    <p class="txt">市区郡 <span class="txt-red">[必須]</span></p>
                    <div class="formparts text">
                      <input type="text" name="" placeholder="テキスト">
                    </div>     
                    <p class="txt">町村域大字 <span class="txt-red">[必須]</span></p>
                    <div class="formparts text">
                      <input type="text" name="" placeholder="テキスト">
                    </div>     
                    <p class="txt">小字以下番地 <span class="txt-red">[必須]</span></p>
                    <div class="formparts text">
                      <input type="text" name="" placeholder="テキスト">
                    </div>   
                    <p class="txt">マンション・ビル名等</p>
                    <div class="formparts text">
                      <input type="text" name="" placeholder="テキスト">
                    </div>            
                  </td>
                </tr>
                <tr>
                  <th class="pt20">
                    <span class="hdg05">備考 <span class="txt-red">[必須]</span></span>
                  </th>
                  <td>
                    <div class="formparts textarea">
                      <textarea name="" id="" rows="5" placeholder="ご質問などがありましたら、ご入力ください。"></textarea>
                    </div>
                    <p class="txt-sup">メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <section id="list">
      <h2 class="guide__title">リスト</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.list01 背景グレーリスト</p>
          <div class="list01">
            <ul>
              <li class="list01-item"><span class="label">リスト項目1階層</span></li>
              <li class="list01-item is-parent is-open">
                <span class="label">リスト項目1階層:子持ち<FontawesomeIcon icon="angle-down" class="icn" /></span>
                <ul>
                  <li class="list01-item"><router-link to="" class="label">リスト項目2階層</router-link></li>
                  <li class="list01-item"><router-link to="" class="label">リスト項目2階層</router-link></li>
                </ul>
              </li>
              <li class="list01-item is-parent is-open">
                <span class="label">リスト項目1階層:子持ち<FontawesomeIcon icon="angle-down" class="icn" /></span>
                <ul>
                  <li class="list01-item"><router-link to="" class="label">リスト項目2階層</router-link></li>
                  <li class="list01-item is-parent is-open">
                    <span class="label">リスト項目2階層:子持ち<FontawesomeIcon icon="angle-down" class="icn" /></span>
                    <ul>
                      <li class="list01-item"><router-link to="" class="label">リスト項目3階層</router-link></li>
                      <li class="list01-item"><router-link to="" class="label">リスト項目3階層</router-link></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="list01-item"><router-link to="" class="label">リスト項目1階層</router-link></li>
            </ul>
          </div>

          <p class="guide__desc">.list01.bg-02 背景黒リスト</p>
          <div style="background-color:#3B4557;">
            <div class="list01 bg-02">
              <ul>
                <li class="list01-item">
                  <div class="label">
                    <div class="formparts checkbox">
                      <input type="checkbox" name="group_cb_02" id="cb_02_01">
                      <label for="cb_02_01">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                  </div>
                </li>
                <li class="list01-item is-parent is-open">
                  <div class="label">
                    <div class="formparts checkbox">
                      <input type="checkbox" name="group_cb_02" id="cb_02_02">
                      <label for="cb_02_02">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                    <FontawesomeIcon icon="angle-down" class="icn icn-down" />
                  </div>
                  <ul>
                    <li class="list01-item">
                      <div class="label">
                        <div class="formparts checkbox">
                          <input type="checkbox" name="group_cb_02" id="cb_02_03">
                          <label for="cb_02_03">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                      </div>
                    </li>
                    <li class="list01-item">
                      <div class="label">
                        <div class="formparts checkbox">
                          <input type="checkbox" name="group_cb_02" id="cb_02_04">
                          <label for="cb_02_04">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li class="list01-item is-parent is-open">
                  <div class="label">
                    <div class="formparts checkbox">
                      <input type="checkbox" name="group_cb_02" id="cb_02_05">
                      <label for="cb_02_05">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                    <FontawesomeIcon icon="angle-down" class="icn icn-down" />
                  </div>     
                  <ul>
                    <li class="list01-item">
                      <div class="label">
                        <div class="formparts checkbox">
                          <input type="checkbox" name="group_cb_02" id="cb_02_06">
                          <label for="cb_02_06">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                      </div>  
                    </li>
                    <li class="list01-item is-parent is-open">
                      <div class="label">
                        <div class="formparts checkbox">
                          <input type="checkbox" name="group_cb_02" id="cb_02_07">
                          <label for="cb_02_07">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                        <FontawesomeIcon icon="angle-down" class="icn icn-down" />
                      </div>  
                      <ul>
                        <li class="list01-item">
                          <div class="label">
                            <div class="formparts checkbox">
                              <input type="checkbox" name="group_cb_02" id="cb_02_08">
                              <label for="cb_02_08">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                            </div>
                          </div>                          
                        </li>
                        <li class="list01-item">
                          <div class="label">
                            <div class="formparts checkbox">
                              <input type="checkbox" name="group_cb_02" id="cb_02_09">
                              <label for="cb_02_09">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                            </div>
                          </div>                          
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="list01-item">
                  <div class="label">
                    <div class="formparts checkbox">
                      <input type="checkbox" name="group_cb_02" id="cb_02_10">
                      <label for="cb_02_10">税務・会計<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <p class="guide__desc">.list02 書籍リスト</p>
          <div class="list02">
            <ul class="list02-list">
              <li class="list02-item">
                <div class="wrap">
                  <div class="label">
                    <router-link to="/pc/qa-detail-4" class="main">追録第25・26号のあらまし</router-link>
                  </div>
                </div>
              </li>
              <li class="list02-item">
                <div class="wrap">
                  <div class="label">
                    <router-link to="/pc/qa-detail" class="main">はしがき</router-link>
                  </div>
                </div>
              </li>
              <li class="list02-item is-parent is-open">
                <div class="wrap">
                  <div class="label">
                    <FontawesomeIcon icon="minus" class="icn-before" />
                    <span class="main">第１章　事業経営の計画・監視</span>
                  </div>
                </div>
                <ul>
                  <li class="list02-item is-parent is-open">
                    <div class="wrap">
                      <div class="label">
                        <FontawesomeIcon icon="minus" class="icn-before" />
                        <span class="main">第１　事業の方針決定、経営の判断</span>
                      </div>
                    </div>
                    <ul>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">図　解</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">基本事項</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                      <li class="list02-item is-parent is-open">
                        <div class="wrap">
                          <div class="label">
                            <FontawesomeIcon icon="minus" class="icn-before" />
                            <span class="main">実務解説</span>
                          </div>
                        </div>
                        <ul>
                          <li class="list02-item">
                            <div class="wrap">
                              <div class="label">
                                <span class="main">新規事業への進出を検討する</span>
                              </div>
                              <ButtonViewLater />
                            </div>
                          </li>
                          <li class="list02-item">
                            <div class="wrap">
                              <div class="label">
                                <span class="main">経営戦略・経営計画を立案・開示する</span>
                              </div>
                              <ButtonViewLater />
                            </div>
                          </li>
                          <li class="list02-item">
                            <div class="wrap">
                              <div class="label">
                                <span class="main">海外事業への進出を検討し、リスクマネジメント体制を構築する</span>
                              </div>
                              <ButtonViewLater />
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="list02-item is-parent is-open">
                    <div class="wrap">
                      <div class="label">
                        <FontawesomeIcon icon="minus" class="icn-before" />
                        <span class="main">第２　事業経営の監視</span>
                        <span class="indent">インデントテキスト<br>インデントテキストインデントテキスト</span>
                        <span class="indent">インデントテキスト</span>
                      </div>
                    </div>
                    <ul>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">図　解</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">基本事項</router-link>
                            <span class="indent">インデントテキスト</span>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">基本事項</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li class="list02-item is-parent is-open">
                    <div class="wrap">
                      <div class="label">
                        <FontawesomeIcon icon="minus" class="icn-before" />
                        <span class="main">第３　内部統制システムの整備・開示</span>
                      </div>
                    </div>
                    <ul>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">図　解</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">基本事項</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                      <li class="list02-item">
                        <div class="wrap">
                          <div class="label">
                            <router-link to="/pc/qa-detail" class="main">基本事項</router-link>
                          </div>
                          <ButtonViewLater />
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="list02-item is-parent">
                <div class="wrap">
                  <div class="label">
                    <FontawesomeIcon icon="plus" class="icn-before" />
                    <span class="main">第２章　会社財産の処分等</span>
                  </div>
                </div>
              </li>
              <li class="list02-item is-parent">
                <div class="wrap">
                  <div class="label">
                    <FontawesomeIcon icon="plus" class="icn-before" />
                    <span class="main">第２章　会社財産の処分等</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <p class="guide__desc">.list03 汎用リスト</p>
          <div class="list03">
            <ul>
              <li>
                <p class="list03-label">ビュレットなし汎用リスト</p>
              </li>
              <li>
                <p class="list03-label">ビュレットなし汎用リスト</p>
                <ul>
                  <li>
                    <p class="list03-label">ビュレットなし汎用リスト</p>
                  </li>
                  <li>
                    <p class="list03-label">ビュレットなし汎用リスト</p>
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="" class="list03-label txt-blue">ビュレットなし汎用リスト</router-link>
              </li>
              <li>
                <p class="list03-label">ビュレットなし汎用リスト</p>
              </li>
            </ul>
          </div>

          <p class="guide__desc">.list-inline inline blockリスト</p>
          <ul class="list-inline">
            <li>第１条</li>
            <li>第２条</li>
            <li>第３条</li>
            <li>第４条</li>
            <li>第５条</li>
            <li>第６条</li>
          </ul>

          <p class="guide__desc">.list-border 罫線リスト</p>
          <ul class="list-border">
            <li class="list-border-item">
              <p class="txt">list-border 罫線リスト</p>
            </li>
            <li class="list-border-item">
              <p class="txt">list-border 罫線リスト</p>
            </li>
            <li class="list-border-item">
              <p class="txt">list-border 罫線リスト</p>
            </li>
            <li class="list-border-item">
              <p class="txt">list-border 罫線リスト</p>
            </li>
            <li class="list-border-item">
              <p class="txt">list-border 罫線リスト</p>
            </li>
          </ul>

          <p class="guide__desc">.list-result ナレッジ検索結果</p>
          <ul class="list-result">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">プロ野球12球団の「税の講義」（2020年1月20日号・№819）</router-link></div>
                <p class="list-result-text"> <strong class="yellow">個人事業</strong>を株式会社として行いたいと考えていますが、<strong class="blue">株式会社</strong>を設立するには、どんな方法があるでしょうか？<br>
                A　株式会社を設立する方法には、設立時発起設立（同時設立または 単純設立 といいます。）と、設立時発行株式の総数の一部を発起人が引き受け、残りの株式について株主の募集を行う募集設立（漸次設立または複雑設立といいます。）の２つがあります。<br>
                解説<br>
                １　株式会社の設立行為<br>
                株式会社を設立するには（200文字）…</p>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <router-link to="" class="list-result-link">ノート（2）</router-link>
                </div>
                <div class="list-result-category">
                  <span class="text">税務・会計</span>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">プロ野球12球団の「税の講義」（2020年1月20日号・№819）</router-link></div>
                <p class="list-result-text"> <strong class="yellow">個人事業</strong>を株式会社として行いたいと考えていますが、<strong class="blue">株式会社</strong>を設立するには、どんな方法があるでしょうか？<br>
                A　株式会社を設立する方法には、設立時発起設立（同時設立または 単純設立 といいます。）と、設立時発行株式の総数の一部を発起人が引き受け、残りの株式について株主の募集を行う募集設立（漸次設立または複雑設立といいます。）の２つがあります。<br>
                解説<br>
                １　株式会社の設立行為<br>
                株式会社を設立するには（200文字）…</p>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-link">※ノートが0件の場合は非表示</span>
                </div>
                <div class="list-result-category">
                  <span class="text">税務・会計</span>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
          </ul>

          <p class="guide__desc">.list-result ナレッジ検索結果（タイトルのみ）</p>
          <ul class="list-result">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">プロ野球12球団の「税の講義」（2020年1月20日号・№819）</router-link></div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">プロ野球12球団の「税の講義」（2020年1月20日号・№819）</router-link></div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
          </ul>

          <p class="guide__desc">.list-result ノート検索結果</p>
          <ul class="list-result">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">プロ野球12球団の「税の講義」（2020年1月20日号・№819）</router-link></div>
                <p class="list-result-text"> <strong class="yellow">個人事業</strong>を株式会社として行いたいと考えていますが、<strong class="blue">株式会社</strong>を設立するには、どんな方法があるでしょうか？<br>
                A　株式会社を設立する方法には、設立時発起設立（同時設立または 単純設立 といいます。）と、設立時発行株式の総数の一部を発起人が引き受け、残りの株式について株主の募集を行う募集設立（漸次設立または複雑設立といいます。）の２つがあります。<br>
                解説<br>
                １　株式会社の設立行為<br>
                株式会社を設立するには（200文字）…</p>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-sup">更新日：2020/03/18</span>
                </div>
                <div class="list-result-auther">
                  <span class="text">
                    <span class="name">作成者：浦島太郎</span>
                    <span class="wrap" style="background-image:url('http://satyr.io/48x1:2');"></span>
                  </span>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">プロ野球12球団の「税の講義」（2020年1月20日号・№819）</router-link></div>
                <p class="list-result-text"> <strong class="yellow">個人事業</strong>を株式会社として行いたいと考えていますが、<strong class="blue">株式会社</strong>を設立するには、どんな方法があるでしょうか？<br>
                A　株式会社を設立する方法には、設立時発起設立（同時設立または 単純設立 といいます。）と、設立時発行株式の総数の一部を発起人が引き受け、残りの株式について株主の募集を行う募集設立（漸次設立または複雑設立といいます。）の２つがあります。<br>
                解説<br>
                １　株式会社の設立行為<br>
                株式会社を設立するには（200文字）…</p>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-sup">更新日：2020/03/18</span>
                </div>
                <div class="list-result-auther">
                  <span class="text">
                    <span class="name">※作成者が自分の場合は非表示</span>
                    <span class="wrap" style="background-image:url('http://satyr.io/48x1:2');"></span>
                  </span>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
          </ul>

          <p class="guide__desc">.list-result QA検索結果 表示設定MAX</p>
          <ul class="list-result">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">吸収分割とは吸収分割の手続はどのように行うのか</router-link></div>
                <p class="list-result-text"> <strong class="yellow">個人事業</strong>を株式会社として行いたいと考えていますが、<strong class="blue">株式会社</strong>を設立するには、どんな方法があるでしょうか？<br>
                A　株式会社を設立する方法には、設立時発起設立（同時設立または 単純設立 といいます。）と、設立時発行株式の総数の一部を発起人が引き受け、残りの株式について株主の募集を行う募集設立（漸次設立または複雑設立といいます。）の２つがあります。<br>
                解説<br>
                １　株式会社の設立行為<br>
                株式会社を設立するには（200文字）…</p>
                <div class="list-result-note">
                  <span class="list-result-sup">内容現在：2020/03/18</span>
                  <router-link to="" class="list-result-link">ノート（2）</router-link>
                  <router-link to="" class="list-result-link">書式ダウンロード</router-link>
                </div>
                <router-link to="" class="list-result-link pl0 pr0">Ｑ＆Ａ　新会社法の実務</router-link>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">吸収分割とは吸収分割の手続はどのように行うのか</router-link></div>
                <p class="list-result-text"> <strong class="yellow">個人事業</strong>を株式会社として行いたいと考えていますが、<strong class="blue">株式会社</strong>を設立するには、どんな方法があるでしょうか？<br>
                A　株式会社を設立する方法には、設立時発起設立（同時設立または 単純設立 といいます。）と、設立時発行株式の総数の一部を発起人が引き受け、残りの株式について株主の募集を行う募集設立（漸次設立または複雑設立といいます。）の２つがあります。<br>
                解説<br>
                １　株式会社の設立行為<br>
                株式会社を設立するには（200文字）…</p>
                <div class="list-result-note">
                  <span class="list-result-sup">内容現在：2020/03/18</span>
                  <router-link to="" class="list-result-link">ノート（2）</router-link>
                  <router-link to="" class="list-result-link">書式ダウンロード</router-link>
                </div>
                <router-link to="" class="list-result-link pl0 pr0">Ｑ＆Ａ　新会社法の実務</router-link>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
          </ul>

          <p class="guide__desc">.list-result QA検索</p>
          <ul class="list-result">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">吸収分割とは吸収分割の手続はどのように行うのか</router-link></div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">吸収分割とは吸収分割の手続はどのように行うのか</router-link></div>
              </div>
              <div class="list-result-item-sub">
                <ButtonViewLater />
              </div>
            </li>
          </ul>

          <p class="guide__desc">.list-result 検索条件</p>
          <ul class="list-result list-result-small">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">QA：消費税</router-link></div>
                <div class="list-result-tags">
                <div class="tag">
                  <div role="button" class="tag-wrap">
                    <span class="tag-text">競馬所得</span>
                  </div>
                </div>
                <div class="tag">
                  <div role="button" class="tag-wrap">
                    <span class="tag-text">競馬所得</span>
                  </div>
                </div>
                <div class="tag">
                  <div role="button" class="tag-wrap">
                    <span class="tag-text">競馬所得</span>
                  </div>
                </div>
              </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">ノート：消費税</router-link></div>
                  <div class="list-result-tags">
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
          </ul>

          <p class="guide__desc">.list-result 後で見る一覧</p>
          <ul class="list-result list-result-small">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">競馬所得の裁判例（2020年2月18日号・№811）</router-link></div>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-sup">最新ナレッジ</span>
                </div>
              </div>
              <ButtonClose />
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">会社役員規程マニュアル</router-link></div>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-sup">2019年度締め</span>
                  <span class="list-result-sup">QA</span>
                </div>
              </div>
              <ButtonClose />
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">株式会社の調査</router-link></div>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-sup">2019年度締め</span>
                  <span class="list-result-sup">QA</span>
                </div>
                <div class="list-result-auther">
                  <span class="text mr12">
                    <span class="name">作成者：浦島太郎</span>
                    <span class="wrap" style="background-image:url('http://satyr.io/48x1:2');"></span>
                  </span>
                  <span class="list-result-sup">ノート</span>
                </div>
              </div>
              <ButtonClose />
            </li>
          </ul>

          <p class="guide__desc">.list-result ブックマーク一覧</p>
          <ul class="list-result list-result-small">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">競馬所得の裁判例（2020年2月18日号・№811）</router-link></div>
                  <div class="list-result-note">
                    <span class="list-result-sup">作成日：2020/03/18</span>
                    <span class="list-result-sup">最新ナレッジ</span>
                  </div>
                  <div class="list-result-tags">
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">ノート：消費税</router-link></div>
                <div class="list-result-note">
                  <span class="list-result-sup">作成日：2020/03/18</span>
                  <span class="list-result-sup">QA</span>
                </div>
                <div class="list-result-tags">
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                  <div class="tag">
                    <div role="button" class="tag-wrap">
                      <span class="tag-text">競馬所得</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
          </ul>

          <p class="guide__desc">.list-result タグ一覧</p>
          <ul class="list-result list-result-small">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title">
                  <router-link to="">
                    <span class="list-result-title-main">消費税</span>
                    <span class="list-result-title-num">(2)</span>
                  </router-link>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title">
                  <router-link to="">
                    <span class="list-result-title-main">消費税</span>
                  </router-link>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title">
                  <router-link to="">
                    <span class="list-result-title-main">消費税</span>
                  </router-link>
                </div>
              </div>
              <div class="list-result-item-sub">
                <ButtonEdit />
              </div>
              <ButtonClose />
            </li>
          </ul>

          <p class="guide__desc">.list-result お知らせ一覧</p>
          <ul class="list-result list-result-small">
            <li class="list-result-item">
              <div class="list-result-item-main">
                <div class="list-result-title"><router-link to="">新刊のお知らせ：株式会社の法律実務</router-link><span class="icon-label gray">重要</span></div>
                <div class="list-result-note">
                  <span class="list-result-sup">書籍の更新情報</span>
                </div>
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main full">
                <div class="list-result-title"><router-link to="">セミナー「在留資格「特定技能」に係る最新の実務運用」（名古屋）の延期のお知らせ</router-link><span class="icon-label red">緊急情報</span></div>
                <div class="list-result-note">
                  <span class="list-result-sup">セミナー情報</span>
                </div>
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main full">
                <div class="list-result-title"><router-link to="">セミナー「在留資格「特定技能」に係る最新の実務運用」（名古屋）の延期のお知らせセミナー「在留資格「特定技能」に係る最新の実務運用」（名古屋）の延期のお知らせセミナー「在留資格「特定技能」に係る最新の実務運用」（名古屋）の延期のお知らせセミナー「在留資格「特定技能」に係る最新の実務運用」（名古屋）の延期のお知らせ</router-link><span class="icon-label red">緊急情報</span></div>
                <div class="list-result-note">
                  <span class="list-result-sup">セミナー情報</span>
                </div>
              </div>
            </li>
            <li class="list-result-item">
              <div class="list-result-item-main full">
                <div class="list-result-title"><span class="no-link">セミナー「在留資格「特定技能」に係る最新の実務運用」（名古屋）の延期のお知らせ</span><span class="icon-label red">緊急情報</span></div>
                <div class="list-result-note">
                  <span class="list-result-sup">セミナー情報</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section id="table">
      <h2 class="guide__title">テーブル</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.tbl01 テーブル横</p>
          <div class="tbl01">
            <table class="tbl">
              <colgroup>
                <col style="width:33.333%;">
                <col style="width:16.666%;">
                <col style="width:16.666%;">
                <col style="width:16.666%;">
                <col style="width:16.666%;">
              </colgroup>
              <thead>
                <tr>
                  <th>パッケージ名</th>
                  <th>状態</th>
                  <th class="ta-center">ライセンス数</th>
                  <th class="ta-right">初回ライセンス開始日</th>
                  <th class="ta-right">ライセンス終了日</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>税務・会計 税務・会計 税務・会計 税務・会計 税務・会計 税務・会計</td>
                  <td>トライアル</td>
                  <td class="ta-center">5</td>
                  <td class="ta-right">2019/12/21</td>
                  <td class="ta-right">2020/12/21</td>
                </tr>
                <tr>
                  <td>税務・会計</td>
                  <td>トライアル</td>
                  <td class="ta-center">5</td>
                  <td class="ta-right">2019/12/21</td>
                  <td class="ta-right">2020/12/21</td>
                </tr>
                <tr>
                  <td>税務・会計</td>
                  <td>トライアル</td>
                  <td class="ta-center">5</td>
                  <td class="ta-right">2019/12/21</td>
                  <td class="ta-right">2020/12/21</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="txt-sup mt32 mb60">※ライセンスの追加は、初回のご入金確認が完了するまでは出来ません。（初回申込時を除く）</p>
          <p class="guide__desc">.tbl02 罫線なし（フォームレイアウトなど）</p>
          <div class="tbl02">
            <table class="tbl">
              <colgroup>
                <col style="width:33.333%;">
                <col style="width:66.666%;">
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    <span class="hdg05">名前 <span class="txt-red">[必須]</span></span>
                  </th>
                  <td>
                    <span class="txt">名前</span>
                    <div class="formparts text">
                      <input type="text" name="" placeholder="山田太郎">
                    </div>
                    <p class="txt-sup">名前に関する注記名前に関する注記名前に関する注記名前に関する注記名前に関する注記名前に関する注記名前に関する注記</p>
                  </td>
                </tr>
                <tr>
                  <th class="pt20">
                    <span class="hdg05">メールアドレス <span class="txt-red">[必須]</span> ※tdの初めの項目が枠付きの場合は ".pt20"</span>
                  </th>
                  <td>
                    <div class="formparts text">
                      <input type="email" name="email" placeholder="yamada-taro@sn-hoki.co.jp">
                    </div>
                    <p class="txt mb16">もう一度入力してください</p>
                    <div class="formparts text">
                      <input type="email" name="email_2" placeholder="yamada-taro@sn-hoki.co.jp">
                    </div>
                    <p class="txt-sup">メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記</p>
                  </td>
                </tr>
                <tr>
                  <th class="pt20">
                    <span class="hdg05">備考 <span class="txt-red">[必須]</span></span>
                  </th>
                  <td>
                    <div class="formparts textarea">
                      <textarea name="" id="" rows="5" placeholder="ご質問などがありましたら、ご入力ください。"></textarea>
                    </div>
                    <p class="txt-sup">メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記メールアドレスに関する注記</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="guide__desc">.tbl03 テーブル縦</p>
          <div class="tbl03">
            <ul class="tbl column">
              <li class="tbl-row column-item col-2">
                <div class="tbl-head">パッケージ名</div>
                <div class="tbl-head">状態</div>
                <div class="tbl-head">ライセンス</div>
                <div class="tbl-head">初回ライセンス開始日</div>
              </li>
              <li class="tbl-row column-item col-2">
                <div class="tbl-data">税務・会計</div>
                <div class="tbl-data">トライアル</div>
                <div class="tbl-data">5</div>
                <div class="tbl-data">2020/03/12</div>
              </li>
              <li class="tbl-row column-item col-2">
                <div class="tbl-data">税務・会計</div>
                <div class="tbl-data">トライアル</div>
                <div class="tbl-data">5</div>
                <div class="tbl-data">2020/03/12</div>
              </li>
              <li class="tbl-row column-item col-2">
                <div class="tbl-data">税務・会計</div>
                <div class="tbl-data">トライアル</div>
                <div class="tbl-data">5</div>
                <div class="tbl-data">2020/03/12</div>
              </li>
              <li class="tbl-row column-item col-2">
                <div class="tbl-data">税務・会計</div>
                <div class="tbl-data">トライアル</div>
                <div class="tbl-data">5</div>
                <div class="tbl-data">2020/03/12</div>
              </li>
              <li class="tbl-row column-item col-2">
                <div class="tbl-data">税務・会計</div>
                <div class="tbl-data">トライアル</div>
                <div class="tbl-data">5</div>
                <div class="tbl-data">2020/03/12</div>
              </li>
            </ul>
          </div>
          <p class="txt-sup mt32 mb60">※ライセンスの追加は、初回のご入金確認が完了するまでは出来ません。（初回申込時を除く）</p>

          <p class="guide__desc">.tbl04 テーブル見出しあり</p>
          <div class="tbl04">
            <div class="tbl04-hdgarea">
              <h3 class="hdg03 mb20">企業・労働</h3>
              <p class="txt mb0">お申し込みいただいたライセンスは、2021/12/31 までご利用いただけます。</p>
            </div>
            <div class="tbl04-bodyarea">
              <table class="tbl04-table">
                <colgroup>
                  <col style="width:40%;">
                  <col sytle="width:20%;">
                  <col sytle="width:20%;">
                  <col sytle="width:20%;">
                </colgroup>
                <thead>
                  <tr>
                    <th></th>
                    <th>ライセンスの種類</th>
                    <th>ライセンス数</th>
                    <th>ライセンス期限</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      <div class="tbl04-table-txt">企業労働 プロ </div>
                    </th>
                    <td>
                      <div class="tbl04-table-txt">基本ライセンス</div>
                    </td>
                    <td>
                      <div class="tbl04-table-txt">5</div>
                    </td>
                    <td>
                      <div class="tbl04-table-txt">12ヶ月</div>
                      <div class="tbl04-table-txt-sub">（2020/12/31 ~ 2021/12/31）</div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="tbl04-bodyarea-hdg">
                <h4 class="hdg03">オプション</h4>
              </div>
              <table class="tbl04-table">
                <colgroup>
                  <col style="width:40%;">
                  <col sytle="width:20%;">
                  <col sytle="width:20%;">
                  <col sytle="width:20%;">
                </colgroup>
                <thead>
                  <tr>
                    <th></th>
                    <th>ライセンスの種類</th>
                    <th>ライセンス数</th>
                    <th>ライセンス期限</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      <div class="tbl04-table-txt">弁護士 オプションA</div>
                    </th>
                    <td>
                      <div class="tbl04-table-txt">基本ライセンス</div>
                      <div class="tbl04-table-txt">追加ライセンス</div>
                    </td>
                    <td>
                      <div class="tbl04-table-txt">5</div>
                      <div class="tbl04-table-txt">5</div>
                    </td>
                    <td>
                      <div class="tbl04-table-txt">12ヶ月</div>
                      <div class="tbl04-table-txt-sub">（2020/12/31 ~ 2021/12/31）</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="button">
      <h2 class="guide__title">ボタン</h2>
      <div class="guide__module">
        <div class="guide__example" style="background-color:transparent;">
          <p class="guide__desc">.button ボタン</p>
          <div class="button fix mb12">
            <button class="btn" type="button" name="button">決定</button>
          </div>
          <div class="button mb12">
            <router-link to="" class="btn">決定</router-link>
          </div>
          <div class="button is-inactive">
            <router-link to="" class="btn">決定</router-link>
          </div>

          <p class="guide__desc">.button.plus(.minus) ボタン</p>
          <div class="button plus mb12">
            <span role="button" class="btn"><FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
          </div>
          <div class="button minus">
            <span role="button" class="btn"><FontawesomeIcon :icon="['fal','minus']" class="icn" /></span>
          </div>

          <p class="guide__desc">.button.close 閉じるボタン</p>
          <div class="button close">
            <span role="button" class="btn"><FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" /></span>
          </div>

          <p class="guide__desc">.button.after 後で見るボタン</p>
          <ButtonViewLater />
          <ButtonViewLater :isChecked="true" />

          <p class="guide__desc">.tag タグ</p>
          <div class="tag">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得</span>
              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
            </div>
          </div>
          <div class="tag">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得</span>
              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
            </div>
          </div>
          <div class="tag">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得</span>
              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
            </div>
          </div>
          <div class="tag">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得競馬所得</span>
              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
            </div>
          </div>
          <div class="tag">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得</span>
            </div>
          </div>
          <div class="tag bottom">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得</span>
            </div>
          </div>

          <p class="guide__desc">.tag 書籍タグ</p>
          <div class="tag tag-result">
            <div class="tag-result-num">300/300</div>
            <div class="tag-result-navi">
              <span role="button" class="label prev">前へ</span>
              <span role="button" class="label next">次へ</span>
            </div>
          </div>

          <p class="guide__desc">.icon-label ラベルアイコン</p>
          <span class="icon-label gray">重要</span>
          <span class="icon-label red">緊急情報</span>

          <div class="button dark mb12">
            <router-link to="" class="btn">決定</router-link>
          </div>
          <div class="button dark is-inactive mb12">
            <router-link to="" class="btn">決定</router-link>
          </div>
          <div class="tag dark bottom">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得</span>
            </div>
          </div>
          <div class="tag dark">
            <div role="button" class="tag-wrap">
              <span class="tag-text">競馬所得</span>
              <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
            </div>
          </div>

        </div>
      </div>
    </section>
    <!-- <section id="popup">
      <h2 class="guide__title">ポップアップ</h2>
      <div class="guide__module">
        <div class="guide__example" style="background-color:transparent;">
          <p class="guide__desc">.popup ポップアップ</p>
          <div class="popup-wrapper">
            <div class="button close">
              <span role="button" class="btn"><FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" /></span>
            </div>
            <div class="popup-container xl">
              <div class="popup mb40">
                <div class="popup-title">
                  <span class="hdg02">検索結果（ポップアップ特大）</span>
                </div>
                <div class="popup-content">
                  <p class="txt">吾輩わがはいは猫である。名前はまだ無い。どこで生れたかとんと見当けんとうがつかぬ。何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪どうあくな種族であったそうだ。この書生というのは時々我々を捕つかまえて煮にて食うという話である。</p>
                </div>
              </div>
            </div>
          </div>

          <div class="popup-wrapper">
            <div class="popup-container lg">
              <div class="button close">
                <span role="button" class="btn"><FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" /></span>
              </div>
              <div class="popup mb40">
                <div class="popup-title">
                  <span class="hdg02">検索結果（ポップアップ大）</span>
                </div>
                <div class="popup-content">
                  <p class="txt">吾輩わがはいは猫である。名前はまだ無い。どこで生れたかとんと見当けんとうがつかぬ。何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪どうあくな種族であったそうだ。この書生というのは時々我々を捕つかまえて煮にて食うという話である。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <section id="tab">
      <h2 class="guide__title">タブ</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.button ボタン</p>
          <div class="tab">
            <div class="tab-head">
              <ul class="tab-label">
                <li role="button" class="is-active">TAB_01</li>
                <li role="button">TAB_02</li>
              </ul>
              <div class="formparts checkbox">
                <input type="checkbox" name="group_cb_03" id="tab_cb_01_01">
                <label for="tab_cb_01_01">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </div>
            <div class="tab-container">
              <div id="tab_cnt_01_01" class="tab-content is-active">
                <p>TAB_01のコンテンツ</p>
              </div>
              <div id="tab_cnt_01_02" class="tab-content">
                <p>TAB_02のコンテンツ</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="">
      <h2 class="guide__title">ヘッダー</h2>
      <div class="guide__module">
        <div class="guide__example">
          <div style="background-color:#525A65;padding:20px 0;">

            <p class="guide__desc">.header QA検索 ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">QA</div>
                <div class="header-search-input">
                  <div class="formparts search mb0">
                    <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                    <input type="text" name="search" placeholder="キーワードを入力">
                    <div class="tip">30,000</div>
                  </div>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="cb_04_01">
                    <label for="cb_04_01">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-link">
                  <router-link to="" class="header-search-link-text">詳細検索</router-link>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header QA検索 ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">QA</div>
                <div class="header-search-input">
                  <div class="formparts search mb0">
                    <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                    <input type="text" name="search" placeholder="キーワードを入力">
                    <div class="tip">30,000</div>
                  </div>
                </div>
                <div class="header-search-link">
                  <router-link to="" class="header-search-link-text">詳細検索</router-link>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="is_fuzzy">
                    <label for="is_fuzzy">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-link">
                  <router-link to="" class="header-search-link-text">検索条件</router-link>
                  <router-link to="" class="header-search-link-text">検索履歴</router-link>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header QA検索条件・検索履歴</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">QA</div>
                <div class="header-search-button">
                  <button class="button">
                    <FontawesomeIcon :icon="['far','search']" size="lg" class="icn" />
                    <span class="text">詳細検索の条件を変更する</span>
                  </button>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="is_fuzzy">
                    <label for="is_fuzzy">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-link">
                  <router-link to="" class="header-search-link-text">検索条件</router-link>
                  <router-link to="" class="header-search-link-text">検索履歴</router-link>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header QA詳細</p>
            <header class="header" style="margin-bottom:120px;">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-tab">
                  <div class="header-search-tab-item is-active">
                    <router-link to="" class="text" role="tab" area-selected>目次</router-link>
                  </div>
                  <div class="header-search-tab-item">
                    <router-link to="" class="text" role="tab">関連情報</router-link>
                  </div>
                </div>
                <div class="header-search-link">
                  <router-link to="" class="header-search-link-text">内容現在</router-link>
                  <router-link to="" class="header-search-link-text">書式ダウンロード</router-link>
                  <router-link to="" class="header-search-link-text">書籍情報</router-link>
                </div>
                <div class="header-search-select">
                  <div class="formparts select">
                    <div class="select-label">最新<FontawesomeIcon icon="angle-down" class="icn" /></div>
                    <div class="select-option">
                      <ul class="select-option-list">
                        <li><label><input type="radio" name="group_rd_03">選択肢1</label></li>
                        <li><label><input type="radio" name="group_rd_03">選択肢2</label></li>
                        <li><label><input type="radio" name="group_rd_03">選択肢3</label></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </form>
              <div class="header-label" role="button"><FontawesomeIcon :icon="['far','bookmark']" size="lg" /></div>
            </header>

            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-tab">
                  <div class="header-search-tab-item">
                    <router-link to="" class="text" role="tab">目次</router-link>
                  </div>
                  <div class="header-search-tab-item is-active">
                    <router-link to="" class="text" role="tab" area-selected>関連情報</router-link>
                  </div>
                </div>
                <div class="header-search-link">
                  <router-link to="" class="header-search-link-text">内容現在</router-link>
                  <router-link to="" class="header-search-link-text">書式ダウンロード</router-link>
                  <router-link to="" class="header-search-link-text">書籍情報</router-link>
                </div>
                <div class="header-search-select">
                  <div class="formparts select">
                    <div class="select-label is-selected">選択済み<FontawesomeIcon icon="angle-down" class="icn" /></div>
                    <div class="select-option">
                      <ul class="select-option-list" hidden>
                        <li><label><input type="radio" name="group_rd_03">選択肢1</label></li>
                        <li><label><input type="radio" name="group_rd_03">選択肢2</label></li>
                        <li><label><input type="radio" name="group_rd_03">選択肢3</label></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </form>
              <div class="header-label is-active" role="button"><FontawesomeIcon :icon="['fas','bookmark']" size="lg" /></div>
            </header>

            <p class="guide__desc">.header ノート検索 ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">ノート</div>
                <div class="header-search-input">
                  <div class="formparts search mb0">
                    <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                    <input type="text" name="search" placeholder="キーワードを入力">
                    <div class="tip">30,000</div>
                  </div>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="cb_04_01">
                    <label for="cb_04_01">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header 書籍検索 ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">書籍</div>
                <div class="header-search-input">
                  <div class="formparts search mb0">
                    <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                    <input type="text" name="search" placeholder="キーワードを入力">
                    <div class="tip">30,000</div>
                  </div>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="cb_04_01">
                    <label for="cb_04_01">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header 書式ダウンロード検索 ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">書式ダウンロード</div>
                <div class="header-search-input">
                  <div class="formparts search mb0">
                    <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                    <input type="text" name="search" placeholder="キーワードを入力">
                    <div class="tip">30,000</div>
                  </div>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="cb_04_01">
                    <label for="cb_04_01">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header 最新ナレッジ検索 ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <form action="" method="post" class="header-search">
                <div class="header-search-title">最新ナレッジ</div>
                <div class="header-search-input">
                  <div class="formparts search mb0">
                    <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                    <input type="text" name="search" placeholder="キーワードを入力">
                    <div class="tip">30,000</div>
                  </div>
                </div>
                <div class="header-search-config">
                  <div class="header-search-config-item formparts checkbox mb0">
                    <input type="checkbox" name="group_cb_04" id="cb_04_01">
                    <label for="cb_04_01">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
                <div class="header-search-arrow">
                  <FontawesomeIcon class="header-search-config-item icon" :icon="['fas','angle-right']" />
                </div>
              </form>
            </header>

            <p class="guide__desc">.header タグ ヘッダー</p>
            <header class="header">
              <div class="header-back">
                <router-link to=""><FontawesomeIcon :icon="['fas','angle-left']" size="lg" /></router-link>
              </div>
              <div class="header-search">
                <div class="header-search-tab">
                  <div class="header-search-tab-item is-active">
                    <router-link to="" class="text">ノートのタグ</router-link>
                  </div>
                  <div class="header-search-tab-item">
                    <router-link to="" class="text">ブックマークのタグ</router-link>
                  </div>
                  <div class="header-search-tab-item">
                    <router-link to="" class="text">検索条件のタグ</router-link>
                  </div>
                </div>
              </div>
            </header>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="menu">
      <h2 class="guide__title">メニュー</h2>
      <div class="guide__module">
        <div class="guide__example">
          <p class="guide__desc">.menu メニュー</p>
          <div class="menu-bar" role="button">
            <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn" />
          </div>
          <p class="guide__desc">.menu メニューオープン</p>
          <div class="menu-bar is-open" role="button">
            <IconMenu class="icn" />
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
// import '@/components/style/PCCommonCSS.vue'

export default defineComponent({
  components: {
  },
  props: {
  },
  setup () {
    const group1 = reactive({
    })
   
    return {
      group1
    }
  }
})
</script>

<style lang="scss">
#guide {
  padding: 15px;
}
#guide__nav {
  list-style: none;
  position: fixed;
  right: 15px;
  z-index: 99;
  background-color: rgba(#fff,.8);
  padding: 10px;
}
.guide__title {
  margin-bottom: 30px;
  background-color: #333;
  padding: 10px;
  color: #fff;
}
.guide__desc {
  color: red;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 10px;
}
.guide__example {
  background-color: #fff;
  padding: 20px;
}
.guide__markup-html {
  width: 100%;
}
.guide__module {
  margin-bottom: 40px;
}
</style>
